import PropTypes from 'prop-types';
import React from 'react';
import styles from './Blocks.module.css';
import Link from './Link';


const Blocks = ({ content, classNames, style, headerTag, mainHeader }) => {
  return (
    <div className={`${styles.mainWrapper} ${classNames.wrapper || ''}`} style={style}>
      {mainHeader ? <Link name={mainHeader} tag={headerTag} className={styles.mainHeader} /> : null}
      <div className={`${styles.cardWrapper} ${classNames.wrapper || ''}`} style={style}>
        {content.map(({ title, subheader, content, image, onMore, onContact }, i) => {
          return (
            <div key={title + i} className={`${styles.cards} ${classNames.cards || ''}`}>
              {title && <Link name={title} className={classNames.title} onClick={onMore} tag={headerTag} />}
              {subheader ? <h3 className={`${styles.subheader}  ${classNames.subheader || ''}`}>{subheader}</h3> : null}
              {content && content.childMarkdownRemark && content.childMarkdownRemark.html && (
                <span
                  className={`${styles.content} ${classNames.content || ''} ${(onMore || onContact) ? styles.moreContent : ''}`}
                  dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }}
                />
              )}
              {image && <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />}
              <div className={styles.buttons}>
                {onMore ? <Link simple className={styles.more} name="MEHR ERFAHREN" onClick={onMore} tag="h3" /> : null}
                {onContact ? <Link simple name="KONTAKT AUFNEHMEN" tag="h4" onClick={onContact} /> : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

Blocks.propTypes = {
  style: PropTypes.object,
  mainHeader: PropTypes.string,
  content: PropTypes.array.isRequired,
  headerTag: PropTypes.string,
  classNames: PropTypes.shape({
    wrapper: PropTypes.string,
    cards: PropTypes.string,
    content: PropTypes.string,
    subheader: PropTypes.string,
  }).isRequired,
};

Blocks.defaultProps = {
  id: '',
  showMore: false,
  classNames: {},
};

export default Blocks;



// WEBPACK FOOTER //
// ./src/components/Blocks.js